import introJS from 'intro.js';
import 'intro.js/introjs.css';
import Vue from 'vue';

export function introTool(params, delay = 10000) {
  const { setOptions, oncomplete, onexit, onafterchange } = params;
  const { steps } = setOptions;
  // 超时检测函数
  const timeOut = delay => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        reject('超时');
      }, delay);
    });
  };

  const waitDom = () => {
    return new Promise(resolve => {
      let t = 0;
      const timer = setInterval(() => {
        if (t < delay) {
          t = t + 500;
        } else {
          clearInterval(timer);
        }
        const complete = allDomIsRender();

        if (complete) {
          timer && clearInterval(timer);
          resolve();
        }
      }, 500);
    });
  };

  const allDomIsRender = () => {
    return steps.every(item => {
      const { element } = item;
      let dom;
      const eleStr = element.substr(1);
      if (element.startsWith('.')) {
        dom = document.getElementsByClassName(eleStr)[0];
      } else if (element.startsWith('#')) {
        if (document.getElementById(eleStr)) {
          dom = document.getElementById(eleStr);
        }
      }
      return dom ? true : false;
    });
  };

  return new Promise((resolve, reject) => {
    Promise.race([waitDom(), timeOut(delay)])
      .then(() => {
        Vue.nextTick(() => {
          const introOb = introJS()
            .setOptions({
              ...setOptions
            })
            .oncomplete((resp, target) => {
              //点击跳过引导
              oncomplete && typeof oncomplete == 'function' && oncomplete(resp, target);
            })
            .onafterchange(() => {
              //下一步切换
              onafterchange && typeof onafterchange == 'function' && onafterchange();
            })
            .onexit(() => {
              //引导结束
              onexit && typeof onexit == 'function' && onexit();
            })
            .start();

          resolve(introOb);
        });
      })
      .catch(err => {
        reject(err);
      });
  });
}
